var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + "." + name : name;
};

export default formatName;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/util/prefixName.js
// module id = y5jr
// module chunks = 1